<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    登良站<br>
站点介绍<br>
登良站位于后海滨路与登良路的交汇处，呈南北走向。车站西侧为蔚蓝海岸，西南侧设有北师大南山附属小学、中学等，东侧目前正在开发，东北侧有中铁大厦，东南侧有天虹总部。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:45	00:25	2号线	2分35秒	5分45秒<br>
莲塘	06:00	23:15	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:50	00:25	2号线	4分钟	5分钟<br>
莲塘	06:00	23:15	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:50	01:15	2号线	4分钟	5分钟<br>
莲塘	06:00	00:15	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
百丽大厦、东滨路、君汇新天地、三湘海尚、深圳湾1号、深圳湾口岸、天虹总部大厦、中心路、海王星辰大厦、海能达全球总部、兰桂路、喜之郎大厦<br><br>
B出入口:<br>
（暂未开通）C出入口<br><br>
D出入口:<br>
北师大附小、创业路、登良路、汉金国际大厦、后海办公楼、后海滨路、后海大道、后海名苑、后海小学、后海新村、南山邮局、南油大厦、南油工业区、南油人人乐、南油小学、世纪广场、蔚蓝海岸（一、二、三期）育德佳园、云海天地、招商名仕花园、中国银行后海支行<br><br>
E出入口:<br>
北师大附中、东滨路、后海批发市场、后海人人乐超市、花园城、金光海景、丽秀服装城、南海花园、南门一坊、南油文化广场、三湘海尚、深圳刑侦局、蔚蓝海岸（一、二期）、文德福花园、沃尔玛、信和广场、招行名仕花园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 登良地铁站<br>
M430、高峰专线138路<br><br>
C出入口:<br>
公交站名： 后海滨登良路口<br>
M201、高峰专线138路<br><br>
D出入口:<br>
公交站名： 蔚蓝海岸三期<br>
M430<br><br>
E出入口:<br>
公交站名： 登良地铁站<br>
M430、高峰专线138路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>